module.exports = __webpack_public_path__ + "fonts/Manrope-700-greek21_f91e858.woff2";